import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { deepCopy } from '../../../../../../common/services/common.service';
import PageLoader from '../../../../../../components/PageLoader';
import { EmailCampaignComponent } from '../components/email-campaign/email-campaign.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { setDisplayText } from '../../../../../../common/services/tag-names.service';
import { selectTagsListItems } from '../../../../../../redux/tags/selector';
import { selectTagNamesListItems } from '../../../../../../redux/tag-names/selector';
import { tagNames } from '../../../../../../redux/tag-names/action';
import { emailCampaigns } from '../../../../../../redux/email-campaigns/action';
import { selectEmailCampaignsQueryItems } from '../../../../../../redux/email-campaigns/selector';
import moment from 'moment';



const EmailCampaign = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectOnePrograms, setSelectOnePrograms] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const AccountTypes = useSelector(selectAccountTypesListItems)
    const Accounts = useSelector(selectAccountsListItems)
    const queryItems = useSelector(selectEmailCampaignsQueryItems)
    const [selectedPlansValues, setSelectedPlansValues] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const libraryData = useSelector(selectListItems)
    const tagentityMappingslist = useSelector(selectTagsListItems)
    const tagNameListItems = useSelector(selectTagNamesListItems)
    const [selectedTemplates, setSelectedTemplates] = useState<any>();
    const [selectedTLocalPlans, setSelectedLocalPlans] = useState<any>();



    const TypeData = libraryData?.result?.Type
    const [
        selectedPlans,
        setSelectedPlans
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])

    const fetchTags = () => {
        dispatch(tagNames.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-values/list`,
            entity: 'tagNames',
            jsonData: {}
        }))
    }

    const fetchQueryById = () => {
        dispatch(emailCampaigns.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/query`, entity: 'emailCampaigns', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedPlans({ ...selectedPlans, [field]: event })
        setSelectOnePrograms({ ...setSelectOnePrograms, [field]: event })
    }

    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }


    useEffect(
        () => {
    

            dispatch(accountTypes.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
                entity: 'accountTypes',
                jsonData: {}
            })).then(() => {
                setIsQuery(true)
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchQueryById()

                } else {
                    setIsLoading(false)
                }
            }).then(() => {

                fetchTags()
            })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedPlans(querydata)

                const oneProgramItemsData: any = queryItems?.result?.items?.CampaignPlans?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        FrequencyId: item?.FrequencyId,
                        StartDateUtc: item?.StartDateUtc,
                        CampaignPlanPolicyId: item?.CampaignPlanPolicyId,
                        CampaignTypeId: item?.CampaignTypeId,
                        MediaMappings: item?.MediaMappings || [],
                        Name: item?.Name,
                        RecipientTagIdInclusions: item?.RecipientTagIdInclusions,
                        IsEnabled: item?.IsEnabled || false,
                        ReplyToEmailInclusions: item?.ReplyToEmailInclusions,
                        EndDateUtc: item?.EndDateUtc,
                        CCTagIdInclusions: item?.CCTagIdInclusions,
                        BCCTagIdInclusions: item?.BCCTagIdInclusions,


                    }
                    return itemData
                })
                setSelectedPlansValues(oneProgramItemsData)

            }
        },
        [isQuery]
    )



    const back = () => {
        navigate('/agencies/promotions/marketing/campaigns2')
    }

    //Save the modal data function
    const handleSaveItem = async (data: any) => {

        const newItem = {
            Id: data?.Id || 0,
            FrequencyId: data?.FrequencyId,
            StartDateUtc: data?.StartDateUtc,
            CampaignPlanPolicyId: data?.CampaignPlanPolicyId,
            CampaignTypeId: data?.CampaignTypeId,
            MediaMappings: data?.MediaMappings || [],
            Name: data?.Name,
            RecipientTagIdInclusions: data?.RecipientTagIdInclusions,
            IsEnabled: data?.IsEnabled || false,
            ReplyToEmailInclusions: data?.ReplyToEmailInclusions,
            EndDateUtc: data?.EndDateUtc,
            CCTagIdInclusions: data?.CCTagIdInclusions,
            BCCTagIdInclusions: data?.BCCTagIdInclusions,
        }

        //Update the new data
        setSelectedPlansValues((prevState: any) => {
            // Check if the item exists by ID
            const exists = prevState.some((item: any) => item.Name == newItem.Name);
            // If it exists, update it, otherwise add the new item
            return exists
                ? prevState.map((item: any) => item.Name == newItem.Name ? newItem : item)
                : [...prevState, newItem];
        });
    
    }

    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Plans</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
  

    //Add the data in the Table Function 
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id || 0
        })
        setSelectOnePrograms(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedPlansValues((prevState: any) =>
            prevState.filter((item: any) => item?.Name !== data?.Name)
        );

    };

  

  
    const handleSelectedTemplates = (data: any) => {

        if (!data?.length) return;
        
        const templateSelected = _.map(data, (item: any) => {
            return {
                OwnerId:  selectedPlans?.Id || 0,
                Description: item?.Description,
                Name: item?.Name,
                Id: item?.Id,
    
            }
        });
        setSelectedLocalPlans(templateSelected);
    }

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )

        const programData = {

            "Id": selectedPlans?.Id || 0,
            "Name": selectedPlans?.Name,
            "CampaignPlanId": selectedTLocalPlans?.[0]?.Id,
            "FrequencyId": selectedPlans?.FrequencyId,
            "RecipientTagIdInclusions": selectedPlans?.RecipientTagIdInclusions || [],
            "ReplyToEmailInclusions": selectedPlans?.ReplyToEmailInclusions || [] ,
            "CCTagIdInclusions": selectedPlans?.CCTagIdInclusions || [] ,
            "BCCTagIdInclusions": selectedPlans?.BCCTagIdInclusions || [] ,
             "StartDate": selectedPlans?.StartDate,
              "EndDate": selectedPlans?.EndDate,
        }

        console.log(programData,"programData")

        if (parmas?.id > 0) {
            await dispatch(emailCampaigns.resetAction({ actionType: 'update' }))
            await dispatch(emailCampaigns.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns`, entity: 'programHubs', jsonData: {
                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(emailCampaigns.resetAction({ actionType: 'create' }))
            await dispatch(emailCampaigns.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns`, entity: 'programHubs', jsonData: {

                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }

    useEffect(() => {
        if (selectedPlans?.AssociatedAccountTypeId) {
            const accountTypeName = AccountTypes?.result?.items.find(
                item => item.Id === selectedPlans.AssociatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                type => type.Text === accountTypeName
            )?.Value;
            (async () => {
                await dispatch(accounts.list({
                    url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
                    entity: 'accounts',
                    jsonData: {
                        "Context": {},
                        "Records": [

                        ],
                        "Pagination": {
                            "Filters": [
                                {
                                    "FieldName": "TypeId",
                                    "FieldType": "enum",
                                    "FilterOperatorId": 1,
                                    "FieldValue": accountTypeValue
                                }
                            ],
                        },

                    }
                }))
                setIsLoading(false);
            })();
        }
    }, [selectedPlans?.AssociatedAccountTypeId]);
    return (
        <>
          
            {isLoading ? <PageLoader /> :

                <EmailCampaignComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedPlans={selectedPlans}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedPlansValues={selectedPlansValues}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                    PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
                    AccountTypes={AccountTypes?.result?.items}
                    Accounts={Accounts?.result?.items}
                     campaignFrequency={libraryData?.result?.CampaignFrequency}
                       tagNames={setDisplayText(tagNameListItems?.result?.items)}
                       handleSelectedTemplates={handleSelectedTemplates}

                />
            }

        </>
    )

}

export default EmailCampaign;